import config from '../config';

export const getOptions = (opts = [], v, k) => {
    return [<option key='temp'>Select One</option>].concat(opts.map((e, idx) => {
        if (typeof e === 'string')
            return <option key={idx} value={e}>{e}</option>
        return <option key={e[v]} value={e[v]}>{e[k]}</option>
    }))
}

const createLink = (obj, actiontype) => {
    const jsonString = JSON.stringify(obj);
    const formurl = config.REACT_APP_FORM_URL;
    // Step 2: Base64-encode the JSON string
    const base64String = btoa(jsonString);

    // Step 3: URL-encode the Base64 string
    const urlEncodedString = encodeURIComponent(base64String);
    const formlink = `${formurl}/${actiontype}?param=${urlEncodedString}`;

    return formlink;
}

export const createFormBuilderLink = (actiontype, formId) => {
    const geturl = config.REACT_APP_API_URL + `/api/Forms/getForm/${formId}`;
    const saveurl = config.REACT_APP_API_URL + `/api/Forms/updateForm/${formId}`;
    const schemaproperty = "schema";
    const dataproperty = "data";
    const fileurl = config.REACT_APP_API_URL + `/api/Forms/uploadfile`;
    const obj = { geturl, saveurl, schemaproperty, dataproperty, fileurl };

    return createLink(obj, actiontype);
}

export const createInspectionLink = (inspectionId, editable) => {
    const geturl = config.REACT_APP_API_URL + `/api/Inspection/GetSimulateInspection/${inspectionId}`;
    const saveurl = config.REACT_APP_API_URL + `/api/Inspection/UpdateSimulateInspection/${inspectionId}`;
    const status = "In Progress";
    const schemaproperty = "schema";
    const dataproperty = "data";
    const fileurl = config.REACT_APP_API_URL + `/api/Forms/uploadfile`;
    const obj = { geturl, saveurl, schemaproperty, dataproperty, status, editable, fileurl };

    console.log(obj);

    return createLink(obj, "view");
}

export const createWorkorderLink = (workorderid, editable) => {
    const geturl = config.REACT_APP_API_URL + `/api/Workorder/GetSimulateWorkorder/${workorderid}`;
    const saveurl = config.REACT_APP_API_URL + `/api/Workorder/UpdateSimulateWorkorder/${workorderid}`;
    const status = "In Progress";
    const schemaproperty = "schema";
    const dataproperty = "data";
    const fileurl = config.REACT_APP_API_URL + `/api/Forms/uploadfile`;
    const obj = { geturl, saveurl, schemaproperty, dataproperty, status, editable, fileurl };

    console.log(obj);

    return createLink(obj, "view");
}

// Add createAssetLink function
export const createAssetLink = (assetId, editable) => {
    const geturl = config.REACT_APP_API_URL + `/api/Assets/GetSimulateAsset/${assetId}`;
    const saveurl = config.REACT_APP_API_URL + `/api/Assets/UpdateSimulateAsset/${assetId}`;
    const schemaproperty = "schema";
    const dataproperty = "data";
    const fileurl = config.REACT_APP_API_URL + `/api/Forms/uploadfile`;

    // Construct the object to pass into createLink
    const obj = { geturl, saveurl, schemaproperty, dataproperty, editable, fileurl };

    // Return the generated URL by calling createLink
    return createLink(obj, "view");
}
